import CreateAccount from 'components/pages/Register/CreateAccount'
import ConfirmEmail from 'components/pages/Register/ConfirmEmail'
import About from 'components/pages/Register/About'
import Goals from 'pages/student/Register/Goal'
import ApolloJourney from 'components/pages/Register/ApolloJourney'
import PassTheTest from 'components/pages/Register/PassTheTest'
import CreateBanners from 'components/pages/Register/CreateBanners'
import SwitchCreateAccount from '../components/pages/Switch/SwitchCreateAccount'

import blockChainDevelopmentTestIcon from 'assets/icon/block-chain-development-test-icon.svg'
import cryptoBasicsTestIcon from 'assets/icon/crypto-basics-test-icon.svg'
import daoTestIcon from 'assets/icon/dao-test-icon.svg'
import defiTestIcon from 'assets/icon/defi-test-icon.svg'
import metaverseTestIcon from 'assets/icon/metaverse-test-icon.svg'
import nftTestIcon from 'assets/icon/nft-test-icon.svg'
import smartContractsTestIcon from 'assets/icon/smart-contracts-test-icon.svg'
import tradingTestIcon from 'assets/icon/trading-test-icon.svg'
import euroIcon from 'assets/icon/euro-icon.svg'
import bitcoinIcon from 'assets/icon/bitcoin-icon.svg'
import ethereumIcon from 'assets/icon/ethereum-icon.svg'
import tetherIcon from 'assets/icon/tether-icon.svg'
import clockRed from 'assets/image/clock-red.png'
import clockBlue from 'assets/image/clock-blue.png'
import clockGreen from 'assets/image/clock-green.png'
import calendarCheckGreen from 'assets/image/calendar-check-green.png'
import walletGreen from 'assets/image/wallet-green.png'

// Import moment if not already implicitly available via index.js re-export
// (Adding import for clarity and safety)
import moment from 'moment'
import KYC from 'components/pages/Register/kyc'

// Backend step codes, aligned with apolop2p-backend/apolo_app/core/utils.py
export const BACKEND_REGISTRATION_CODES = {
  EMAIL_VERIFICATION: 'email_verification',
  PROFILE_UPDATE: 'profile_update',
  STUDENT_GOALS: 'student_goals',
  TUTOR_TEST: 'tutor_test',
  TUTOR_KYC: 'tutor_kyc',
  TUTOR_CREATE_BANNER: 'tutor_create_banner',
  COMPLETED: 'profile_completed',
}

// Mapping backend codes to frontend display properties and components
// This provides a central place to manage the details for each step.
export const registrationStepDetails = {
  [BACKEND_REGISTRATION_CODES.EMAIL_VERIFICATION]: {
    label: 'Confirm Email',
    component: ConfirmEmail,
    code: BACKEND_REGISTRATION_CODES.EMAIL_VERIFICATION,
  },
  [BACKEND_REGISTRATION_CODES.PROFILE_UPDATE]: {
    label: 'About Info',
    component: About,
    code: BACKEND_REGISTRATION_CODES.PROFILE_UPDATE,
  },
  [BACKEND_REGISTRATION_CODES.STUDENT_GOALS]: {
    label: 'Set up Your Goals',
    component: Goals,
    code: BACKEND_REGISTRATION_CODES.STUDENT_GOALS,
  }, // Student specific
  [BACKEND_REGISTRATION_CODES.TUTOR_TEST]: {
    label: 'Pass the Test',
    component: PassTheTest,
    code: BACKEND_REGISTRATION_CODES.TUTOR_TEST,
  }, // Tutor specific
  [BACKEND_REGISTRATION_CODES.TUTOR_KYC]: {
    label: 'KYC',
    component: KYC /* TODO: Add KYCComponent if available */,
    code: BACKEND_REGISTRATION_CODES.TUTOR_KYC,
  }, // Tutor specific
  [BACKEND_REGISTRATION_CODES.TUTOR_CREATE_BANNER]: {
    label: 'Create Banners',
    component: CreateBanners,
    code: BACKEND_REGISTRATION_CODES.TUTOR_CREATE_BANNER,
  }, // Tutor specific
  [BACKEND_REGISTRATION_CODES.COMPLETED]: {
    label: 'Start Your Apolo Journey',
    component: ApolloJourney,
    code: BACKEND_REGISTRATION_CODES.COMPLETED,
  },
}

export const studentRegistrationSteps = [
  {
    label: 'Create Account', // Initial frontend step, pre-backend status
    step: 1, // Numerical order for frontend flow
    component: CreateAccount,
    code: 'create_account', // Local frontend code for this initial step
  },
  {
    ...registrationStepDetails[BACKEND_REGISTRATION_CODES.EMAIL_VERIFICATION],
    step: 2,
  },
  {
    ...registrationStepDetails[BACKEND_REGISTRATION_CODES.PROFILE_UPDATE],
    step: 3,
  },
  {
    ...registrationStepDetails[BACKEND_REGISTRATION_CODES.STUDENT_GOALS],
    step: 4,
  },
  {
    ...registrationStepDetails[BACKEND_REGISTRATION_CODES.COMPLETED],
    step: 5,
  },
]

export const tutorRegistrationSteps = [
  {
    label: 'Create Account', // Initial frontend step, pre-backend status
    step: 1, // Numerical order for frontend flow
    component: CreateAccount,
    code: 'create_account', // Local frontend code for this initial step
  },
  {
    ...registrationStepDetails[BACKEND_REGISTRATION_CODES.EMAIL_VERIFICATION],
    step: 2,
  },
  {
    ...registrationStepDetails[BACKEND_REGISTRATION_CODES.PROFILE_UPDATE],
    step: 3,
  },
  {
    ...registrationStepDetails[BACKEND_REGISTRATION_CODES.TUTOR_TEST],
    step: 4,
  },
  {
    ...registrationStepDetails[BACKEND_REGISTRATION_CODES.TUTOR_KYC],
    step: 5,
  },
  {
    ...registrationStepDetails[BACKEND_REGISTRATION_CODES.TUTOR_CREATE_BANNER],
    step: 6,
  },
  {
    ...registrationStepDetails[BACKEND_REGISTRATION_CODES.COMPLETED],
    step: 7,
  },
]

export const studentSwitchSteps = [
  {
    label: 'Create Account',
    step: 1,
    component: SwitchCreateAccount,
  },
  {
    label: 'Set up Your Goals',
    step: 2,
    component: Goals,
  },
  {
    label: 'Start Your Apolo Journey',
    step: 3,
    component: ApolloJourney,
  },
]

export const tutorSwitchSteps = [
  {
    label: 'Create Account',
    step: 1,
    component: SwitchCreateAccount,
  },
  {
    label: 'Pass the Test',
    step: 2,
    component: PassTheTest,
  },
  {
    label: 'KYC',
    step: 3,
  },
  {
    label: 'Create Banners',
    step: 4,
    component: CreateBanners,
  },
  {
    label: 'Start Your Apolo Journey',
    step: 5,
    component: ApolloJourney,
  },
]

export const tutorRegistrationTests = [
  {
    id: 1,
    title: 'Crypto Basics',
    name: 'Crypto Basics',
    description:
      'Fundamental concepts in cryptocurrencies, blockchain technology, and decentralized systems.',
    icon: cryptoBasicsTestIcon,
    slug: 'cryptocurrencies-basic',
  },

  {
    id: 2,
    title: 'Metaverse',
    name: 'Metaverse',
    description:
      'Understanding of the metaverse, an interconnected realm of virtual environments and the evolving digital landscape.',
    icon: metaverseTestIcon,
    slug: 'metaverse',
  },
  {
    id: 3,
    title: 'NFT',
    name: 'NFT',
    description:
      'Expertise in unique digital assets that validate ownership and authenticity across a diverse range of items, from digital to real-world items.',
    icon: nftTestIcon,
    slug: 'nft',
  },

  {
    id: 4,
    title: 'Trading',
    name: 'Trading',
    description:
      'Proficiency in effective trading strategies for various financial instruments, including stocks and cryptocurrencies.',
    icon: tradingTestIcon,
    slug: 'trading',
  },
  {
    id: 5,
    title: 'DeFi',
    name: 'DeFi',
    description:
      'Knowledge of open and permissionless financial ecosystem built on blockchain and their intricacies (borrowing, lending, etc.).',
    icon: defiTestIcon,
    slug: 'defi',
  },
  {
    id: 8,
    title: 'DAO',
    name: 'DAO',
    description:
      'Understanding of organizations governed by self-executing code on blockchains, revolutionizing decision-making, operations and the dynamics.',
    icon: daoTestIcon,
    slug: 'dao',
  },
  {
    id: 7,
    title: 'Blockchain Development',
    name: 'Blockchain Development',
    description:
      'Develop applications and solutions utilizing blockchain technology, with a focused emphasis on programming languages like Solidity and Rust.',
    icon: blockChainDevelopmentTestIcon,
    slug: 'blockchain-development',
  },
  {
    id: 6,
    title: 'Smart Contracts',
    name: 'Smart Contracts',
    description:
      'Comprehension of self-executing contracts encoded onto blockchains, automating and securing diverse processes.',
    icon: smartContractsTestIcon,
    slug: 'smart-contracts',
  },
]

export const studentQuizzes = {
  successPercent: 80,
  started: 122,
  passed: 108,
  fail: 14,
  inProgress: [
    {
      id: 1,
      name: 'NFT',
      tutor: 'Daniella Meli',
      tasksCount: 20,
      completedTasksCount: 16,
      image: '/assets/image/nftImage.png',
    },
    {
      id: 2,
      name: 'Trading',
      tutor: 'Sebastian Eel',
      tasksCount: 14,
      completedTasksCount: 7,
      image: '/assets/image/stock-market 1.png',
    },
    {
      id: 3,
      name: 'NFT',
      tutor: 'Daniella Meli',
      tasksCount: 20,
      completedTasksCount: 16,
      image: '/assets/image/nftImage.png',
    },
    {
      id: 4,
      name: 'Trading',
      tutor: 'Sebastian Eel',
      tasksCount: 14,
      completedTasksCount: 7,
      image: '/assets/image/stock-market 1.png',
    },
  ],
}

export const topTutors = [
  {
    id: 1,
    name: 'Michael Davis',
    check: 2.478,
    users: 24,
    rate: 4.8,
    roi: 36,
    coins: 100,
    image: '/assets/image/toptutorsUser-1.png',
  },
  {
    id: 2,
    name: 'Lana Steiner',
    check: 2.523,
    users: 18,
    rate: 4.3,
    roi: 30,
    coins: 90,
    image: '/assets/image/topTutorUser2.png',
  },
  {
    id: 3,
    name: 'Natali Craig',
    check: 2.325,
    users: 16,
    rate: 4.1,
    roi: 28,
    coins: 85,
    image: '/assets/image/topTutorUser3.png',
  },
  {
    id: 4,
    name: 'Michael Davis',
    check: 2.478,
    users: 24,
    rate: 4.8,
    roi: 36,
    coins: 100,
    image: '/assets/image/toptutorsUser-1.png',
  },
  {
    id: 5,
    name: 'Lana Steiner',
    check: 2.523,
    users: 18,
    rate: 4.3,
    roi: 30,
    coins: 90,
    image: '/assets/image/topTutorUser2.png',
  },
  {
    id: 6,
    name: 'Natali Craig',
    check: 2.325,
    users: 16,
    rate: 4.1,
    roi: 28,
    coins: 85,
    image: '/assets/image/topTutorUser3.png',
  },
  {
    id: 7,
    name: 'Natali Craig',
    check: 2.325,
    users: 16,
    rate: 4.1,
    roi: 28,
    coins: 85,
    image: '/assets/image/topTutorUser3.png',
  },
  {
    id: 8,
    name: 'Natali Craig',
    check: 2.325,
    users: 16,
    rate: 4.1,
    roi: 28,
    coins: 85,
    image: '/assets/image/topTutorUser3.png',
  },
]

export const tutorNews = [
  {
    id: 1,
    name: 'Bitcoin hits all-time high, surging past $60,000',
    site: 'cnbc.com',
    date: 'Today 08:44 PM',
    readTime: '4 min',
    image: '/assets/image/NewsUser(1).png',
  },
  {
    id: 2,
    name: 'Tesla buys $1.5 billion in Bitcoin, announces Tesla buys $1.5 billion in Bitcoin, announces Tesla buys $1.5 billion in Bitcoin, announces',
    site: 'reuters.com',
    date: 'MAY 26, 2023 12:30 PM',
    readTime: '5 min',
    image: '/assets/image/NewsUser(1).png',
  },
  {
    id: 3,
    name: 'Major investment bank launches cryptocurr Major investment bank launches cryptocurr Major investment bank launches cryptocurr',
    site: 'etnow.com',
    date: 'MAY 26, 2023 09:30 AM',
    readTime: '7 min',
    image: '/assets/image/NewsUser(1).png',
  },
]

// Rename original array for 'Today'
export const todayNotificationItems = [
  {
    id: 1,
    title: 'You have cancelled the <b>Metaverse Class</b> with <b>Jean Talis</b>',
    new: true,
    description:
      "Please note that you can't cancel more than 30% of your weekly classes (maximum limit of 5 classes).",
    reason: 'Not interested with the student',
    mark: true,
    date: 'just now',
    image: clockRed,
  },
  {
    id: 2,
    title: 'You have upcoming class with <b>Fay Nabila</b>',
    new: true,
    description:
      'Be ready for your upcoming class! Come prepared with an open mind and necessary materials to make the most of your learning experience with your student!',
    mark: true,
    date: 'in 30 mins',
    image: '/assets/image/toptutorsUser-1.png',
  },
  {
    id: 3,
    title: 'Your <b>NFT Class</b> has been booked by <b>Anne Hathaway</b>',
    new: true,
    description:
      "Congratulations! A student has just booked your class. Take a moment to review and accept the booking to secure your next teaching opportunity. Let's get started!",
    mark: true,
    date: '5 min ago',
    image: '/assets/image/toptutorsUser-1.png',
    accept: true,
  },
  // Add more 'Today' specific notifications if needed
]

// Create new array for 'Yesterday'
export const yesterdayNotificationItems = [
  {
    id: 6, // Use unique IDs if necessary, or adjust based on real data fetching
    title: '<b>Jacob Ladder</b> has accepted your time change request on <b>Metaverse Class</b>',
    new: false, // Likely not 'new' anymore
    description:
      "Good news! Your student just accepted your time change request. Don't waste this opportunity and be prepared to show your best to your student!",
    mark: false,
    date: 'Yesterday 04:30 PM',
    image: clockGreen,
  },
  {
    id: 7,
    title:
      'You just requested a time change for your <b>Metaverse Class</b> with <b>Jacob Ladder</b>',
    new: false,
    description:
      'Your request has been sent to the student for review. If the student declined your request, you have to take the class as scheduled. If you are no-show, it will count as a cancelled class.',
    mark: false,
    date: 'Yesterday 09:08 AM',
    image: clockBlue,
  },
  {
    id: 10,
    title:
      'You earned <b>€ 16.72</b> from completing the <b>NFT Class</b> with <b>Liam Wielson</b>',
    new: false,
    description:
      'Congratulations on completing your class! A valuable credential was added to your balance. Keep up the great work!',
    mark: false,
    date: 'Yesterday 08:00 AM',
    image: walletGreen,
  },
]

// Create new array for 'This Week'
export const weekNotificationItems = [
  {
    id: 8,
    title: 'You have new message from <b>Jacob Ladder</b>',
    new: false,
    description: '"Sure, buddy. Let\'s get another schedule for us."',
    mark: false,
    date: '3 days ago',
    image: '/assets/image/toptutorsUser-1.png',
  },
  {
    id: 9,
    title: 'You just accepted the <b>Metaverse Class</b> with <b>Jacob Ladder</b>',
    new: false,
    description:
      'Thank you! Get ready to share your expertise and guide your student towards success. We wish you a productive and fulfilling teaching experience.',
    mark: false,
    date: 'Apr 24, 11:15 AM', // Example date within the week
    image: calendarCheckGreen,
  },
  {
    id: 11, // Example new ID
    title: 'Reminder: KYC verification pending',
    new: false,
    description: 'Please complete your KYC verification to unlock full platform features.',
    mark: true, // Maybe keep marked until done
    date: '4 days ago',
    image: '/assets/icon/alert-icon.svg', // Example different icon
  },
]

// Create new array for 'This Month'
export const monthNotificationItems = [
  {
    id: 12, // Example new ID
    title: 'Your payout of €250.50 was processed',
    new: false,
    description: 'Your earnings for the previous period have been sent to your linked account.',
    mark: false,
    date: 'Apr 15, 08:00 AM',
    image: walletGreen,
  },
  {
    id: 13,
    title: 'New course available: Advanced DeFi Strategies',
    new: false,
    description: 'Expand your expertise! Check out the new advanced course available for tutors.',
    mark: false,
    date: 'Apr 5, 09:00 AM',
    image: '/assets/icon/book-icon.svg', // Example different icon
  },
]

// Calculate yesterday's date string
const yesterdayDateString = moment().subtract(1, 'days').format('MMMM D, YYYY') // e.g., April 25, 2025

export const notificationSections = [
  {
    id: 1,
    date: 'Today',
    notifications: todayNotificationItems, // Use Today's items
  },
  {
    id: 2,
    date: yesterdayDateString,
    notifications: yesterdayNotificationItems, // Use Yesterday's items
  },
  {
    id: 3,
    date: 'This Week',
    notifications: weekNotificationItems, // Use This Week's items
  },
  {
    id: 4,
    date: 'This Month',
    notifications: monthNotificationItems, // Use This Month's items
  },
]

export const testPassedStatuses = {
  PASSED_ALL: 'PASSED_ALL',
  PASSED_PARTIAL: 'PASSED_PARTIAL',
  FAILED_ALL: 'FAILED_ALL',
  FAILED_PARTIAL: 'FAILED_PARTIAL',
  FLAGGED: 'FLAGGED',
  CANCELED_PARTIAL: 'CANCELED_PARTIAL',
}

export const countryCodes = [
  {
    name: 'Afghanistan',
    dial_code: '+93',
    emoji: '🇦🇫',
    code: 'AF',
  },
  {
    name: 'Aland Islands',
    dial_code: '+358',
    emoji: '🇦🇽',
    code: 'AX',
  },
  {
    name: 'Albania',
    dial_code: '+355',
    emoji: '🇦🇱',
    code: 'AL',
  },
  {
    name: 'Algeria',
    dial_code: '+213',
    emoji: '🇩🇿',
    code: 'DZ',
  },
  {
    name: 'AmericanSamoa',
    dial_code: '+1684',
    emoji: '🇦🇸',
    code: 'AS',
  },
  {
    name: 'Andorra',
    dial_code: '+376',
    emoji: '🇦🇩',
    code: 'AD',
  },
  {
    name: 'Angola',
    dial_code: '+244',
    emoji: '🇦🇴',
    code: 'AO',
  },
  {
    name: 'Anguilla',
    dial_code: '+1264',
    emoji: '🇦🇮',
    code: 'AI',
  },
  {
    name: 'Antarctica',
    dial_code: '+672',
    emoji: '🇦🇶',
    code: 'AQ',
  },
  {
    name: 'Antigua and Barbuda',
    dial_code: '+1268',
    emoji: '🇦🇬',
    code: 'AG',
  },
  {
    name: 'Argentina',
    dial_code: '+54',
    emoji: '🇦🇷',
    code: 'AR',
  },
  {
    name: 'Armenia',
    dial_code: '+374',
    emoji: '🇦🇲',
    code: 'AM',
  },
  {
    name: 'Aruba',
    dial_code: '+297',
    emoji: '🇦🇼',
    code: 'AW',
  },
  {
    name: 'Australia',
    dial_code: '+61',
    emoji: '🇦🇺',
    code: 'AU',
  },
  {
    name: 'Austria',
    dial_code: '+43',
    emoji: '🇦🇹',
    code: 'AT',
  },
  {
    name: 'Azerbaijan',
    dial_code: '+994',
    emoji: '🇦🇿',
    code: 'AZ',
  },
  {
    name: 'Bahamas',
    dial_code: '+1242',
    emoji: '🇧🇸',
    code: 'BS',
  },
  {
    name: 'Bahrain',
    dial_code: '+973',
    emoji: '🇧🇭',
    code: 'BH',
  },
  {
    name: 'Bangladesh',
    dial_code: '+880',
    emoji: '🇧🇩',
    code: 'BD',
  },
  {
    name: 'Barbados',
    dial_code: '+1246',
    emoji: '🇧🇧',
    code: 'BB',
  },
  {
    name: 'Belarus',
    dial_code: '+375',
    emoji: '🇧🇾',
    code: 'BY',
  },
  {
    name: 'Belgium',
    dial_code: '+32',
    emoji: '🇧🇪',
    code: 'BE',
  },
  {
    name: 'Belize',
    dial_code: '+501',
    emoji: '🇧🇿',
    code: 'BZ',
  },
  {
    name: 'Benin',
    dial_code: '+229',
    emoji: '🇧🇯',
    code: 'BJ',
  },
  {
    name: 'Bermuda',
    dial_code: '+1441',
    emoji: '🇧🇲',
    code: 'BM',
  },
  {
    name: 'Bhutan',
    dial_code: '+975',
    emoji: '🇧🇹',
    code: 'BT',
  },
  {
    name: 'Bolivia, Plurinational State of',
    dial_code: '+591',
    emoji: '🇧🇴',
    code: 'BO',
  },
  {
    name: 'Bosnia and Herzegovina',
    dial_code: '+387',
    emoji: '🇧🇦',
    code: 'BA',
  },
  {
    name: 'Botswana',
    dial_code: '+267',
    emoji: '🇧🇼',
    code: 'BW',
  },
  {
    name: 'Brazil',
    dial_code: '+55',
    emoji: '🇧🇷',
    code: 'BR',
  },
  {
    name: 'British Indian Ocean Territory',
    dial_code: '+246',
    emoji: '🇮🇴',
    code: 'IO',
  },
  {
    name: 'Brunei Darussalam',
    dial_code: '+673',
    emoji: '🇧🇳',
    code: 'BN',
  },
  {
    name: 'Bulgaria',
    dial_code: '+359',
    emoji: '🇧🇬',
    code: 'BG',
  },
  {
    name: 'Burkina Faso',
    dial_code: '+226',
    emoji: '🇧🇫',
    code: 'BF',
  },
  {
    name: 'Burundi',
    dial_code: '+257',
    emoji: '🇧🇮',
    code: 'BI',
  },
  {
    name: 'Cambodia',
    dial_code: '+855',
    emoji: '🇰🇭',
    code: 'KH',
  },
  {
    name: 'Cameroon',
    dial_code: '+237',
    emoji: '🇨🇲',
    code: 'CM',
  },
  {
    name: 'Canada',
    dial_code: '+1',
    emoji: '🇨🇦',
    code: 'CA',
  },
  {
    name: 'Cape Verde',
    dial_code: '+238',
    emoji: '🇨🇻',
    code: 'CV',
  },
  {
    name: 'Cayman Islands',
    dial_code: '+345',
    emoji: '🇰🇾',
    code: 'KY',
  },
  {
    name: 'Central African Republic',
    dial_code: '+236',
    emoji: '🇨🇫',
    code: 'CF',
  },
  {
    name: 'Chad',
    dial_code: '+235',
    emoji: '🇹🇩',
    code: 'TD',
  },
  {
    name: 'Chile',
    dial_code: '+56',
    emoji: '🇨🇱',
    code: 'CL',
  },
  {
    name: 'China',
    dial_code: '+86',
    emoji: '🇨🇳',
    code: 'CN',
  },
  {
    name: 'Christmas Island',
    dial_code: '+61',
    emoji: '🇨🇽',
    code: 'CX',
  },
  {
    name: 'Cocos (Keeling) Islands',
    dial_code: '+61',
    emoji: '🇨🇨',
    code: 'CC',
  },
  {
    name: 'Colombia',
    dial_code: '+57',
    emoji: '🇨🇴',
    code: 'CO',
  },
  {
    name: 'Comoros',
    dial_code: '+269',
    emoji: '🇰🇲',
    code: 'KM',
  },
  {
    name: 'Congo',
    dial_code: '+242',
    emoji: '🇨🇬',
    code: 'CG',
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    dial_code: '+243',
    emoji: '🇨🇩',
    code: 'CD',
  },
  {
    name: 'Cook Islands',
    dial_code: '+682',
    emoji: '🇨🇰',
    code: 'CK',
  },
  {
    name: 'Costa Rica',
    dial_code: '+506',
    emoji: '🇨🇷',
    code: 'CR',
  },
  {
    name: "Cote d'Ivoire",
    dial_code: '+225',
    emoji: '🇨🇮',
    code: 'CI',
  },
  {
    name: 'Croatia',
    dial_code: '+385',
    emoji: '🇭🇷',
    code: 'HR',
  },
  {
    name: 'Cuba',
    dial_code: '+53',
    emoji: '🇨🇺',
    code: 'CU',
  },
  {
    name: 'Cyprus',
    dial_code: '+357',
    emoji: '🇨🇾',
    code: 'CY',
  },
  {
    name: 'Czech Republic',
    dial_code: '+420',
    emoji: '🇨🇿',
    code: 'CZ',
  },
  {
    name: 'Denmark',
    dial_code: '+45',
    emoji: '🇩🇰',
    code: 'DK',
  },
  {
    name: 'Djibouti',
    dial_code: '+253',
    emoji: '🇩🇯',
    code: 'DJ',
  },
  {
    name: 'Dominica',
    dial_code: '+1767',
    emoji: '🇩🇲',
    code: 'DM',
  },
  {
    name: 'Dominican Republic',
    dial_code: '+1849',
    emoji: '🇩🇴',
    code: 'DO',
  },
  {
    name: 'Ecuador',
    dial_code: '+593',
    emoji: '🇪🇨',
    code: 'EC',
  },
  {
    name: 'Egypt',
    dial_code: '+20',
    emoji: '🇪🇬',
    code: 'EG',
  },
  {
    name: 'El Salvador',
    dial_code: '+503',
    emoji: '🇸🇻',
    code: 'SV',
  },
  {
    name: 'Equatorial Guinea',
    dial_code: '+240',
    emoji: '🇬🇶',
    code: 'GQ',
  },
  {
    name: 'Eritrea',
    dial_code: '+291',
    emoji: '🇪🇷',
    code: 'ER',
  },
  {
    name: 'Estonia',
    dial_code: '+372',
    emoji: '🇪🇪',
    code: 'EE',
  },
  {
    name: 'Ethiopia',
    dial_code: '+251',
    emoji: '🇪🇹',
    code: 'ET',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    dial_code: '+500',
    emoji: '🇫🇰',
    code: 'FK',
  },
  {
    name: 'Faroe Islands',
    dial_code: '+298',
    emoji: '🇫🇴',
    code: 'FO',
  },
  {
    name: 'Fiji',
    dial_code: '+679',
    emoji: '🇫🇯',
    code: 'FJ',
  },
  {
    name: 'Finland',
    dial_code: '+358',
    emoji: '🇫🇮',
    code: 'FI',
  },
  {
    name: 'France',
    dial_code: '+33',
    emoji: '🇫🇷',
    code: 'FR',
  },
  {
    name: 'French Guiana',
    dial_code: '+594',
    emoji: '🇬🇫',
    code: 'GF',
  },
  {
    name: 'French Polynesia',
    dial_code: '+689',
    emoji: '🇵🇫',
    code: 'PF',
  },
  {
    name: 'Gabon',
    dial_code: '+241',
    emoji: '🇬🇦',
    code: 'GA',
  },
  {
    name: 'Gambia',
    dial_code: '+220',
    emoji: '🇬🇲',
    code: 'GM',
  },
  {
    name: 'Georgia',
    dial_code: '+995',
    emoji: '🇬🇪',
    code: 'GE',
  },
  {
    name: 'Germany',
    dial_code: '+49',
    emoji: '🇩🇪',
    code: 'DE',
  },
  {
    name: 'Ghana',
    dial_code: '+233',
    emoji: '🇬🇭',
    code: 'GH',
  },
  {
    name: 'Gibraltar',
    dial_code: '+350',
    emoji: '🇬🇮',
    code: 'GI',
  },
  {
    name: 'Greece',
    dial_code: '+30',
    emoji: '🇬🇷',
    code: 'GR',
  },
  {
    name: 'Greenland',
    dial_code: '+299',
    emoji: '🇬🇱',
    code: 'GL',
  },
  {
    name: 'Grenada',
    dial_code: '+1473',
    emoji: '🇬🇩',
    code: 'GD',
  },
  {
    name: 'Guadeloupe',
    dial_code: '+590',
    emoji: '🇬🇵',
    code: 'GP',
  },
  {
    name: 'Guam',
    dial_code: '+1671',
    emoji: '🇬🇺',
    code: 'GU',
  },
  {
    name: 'Guatemala',
    dial_code: '+502',
    emoji: '🇬🇹',
    code: 'GT',
  },
  {
    name: 'Guernsey',
    dial_code: '+44',
    emoji: '🇬🇬',
    code: 'GG',
  },
  {
    name: 'Guinea',
    dial_code: '+224',
    emoji: '🇬🇳',
    code: 'GN',
  },
  {
    name: 'Guinea-Bissau',
    dial_code: '+245',
    emoji: '🇬🇼',
    code: 'GW',
  },
  {
    name: 'Guyana',
    dial_code: '+595',
    emoji: '🇬🇾',
    code: 'GY',
  },
  {
    name: 'Haiti',
    dial_code: '+509',
    emoji: '🇭🇹',
    code: 'HT',
  },
  {
    name: 'Holy See (Vatican City State)',
    dial_code: '+379',
    emoji: '🇻🇦',
    code: 'VA',
  },
  {
    name: 'Honduras',
    dial_code: '+504',
    emoji: '🇭🇳',
    code: 'HN',
  },
  {
    name: 'Hong Kong',
    dial_code: '+852',
    emoji: '🇭🇰',
    code: 'HK',
  },
  {
    name: 'Hungary',
    dial_code: '+36',
    emoji: '🇭🇺',
    code: 'HU',
  },
  {
    name: 'Iceland',
    dial_code: '+354',
    emoji: '🇮🇸',
    code: 'IS',
  },
  {
    name: 'India',
    dial_code: '+91',
    emoji: '🇮🇳',
    code: 'IN',
  },
  {
    name: 'Indonesia',
    dial_code: '+62',
    emoji: '🇮🇩',
    code: 'ID',
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf',
    dial_code: '+98',
    emoji: '🇮🇷',
    code: 'IR',
  },
  {
    name: 'Iraq',
    dial_code: '+964',
    emoji: '🇮🇷',
    code: 'IQ',
  },
  {
    name: 'Ireland',
    dial_code: '+353',
    emoji: '🇮🇪',
    code: 'IE',
  },
  {
    name: 'Isle of Man',
    dial_code: '+44',
    emoji: '🇮🇲',
    code: 'IM',
  },
  {
    name: 'Israel',
    dial_code: '+972',
    emoji: '🇮🇱',
    code: 'IL',
  },
  {
    name: 'Italy',
    dial_code: '+39',
    emoji: '🇮🇹',
    code: 'IT',
  },
  {
    name: 'Jamaica',
    dial_code: '+1876',
    emoji: '🇯🇲',
    code: 'JM',
  },
  {
    name: 'Japan',
    dial_code: '+81',
    emoji: '🇯🇵',
    code: 'JP',
  },
  {
    name: 'Jersey',
    dial_code: '+44',
    emoji: '🇯🇪',
    code: 'JE',
  },
  {
    name: 'Jordan',
    dial_code: '+962',
    emoji: '🇯🇴',
    code: 'JO',
  },
  {
    name: 'Kazakhstan',
    dial_code: '+77',
    emoji: '🇰🇿',
    code: 'KZ',
  },
  {
    name: 'Kenya',
    dial_code: '+254',
    emoji: '🇰🇪',
    code: 'KE',
  },
  {
    name: 'Kiribati',
    dial_code: '+686',
    emoji: '🇰🇮',
    code: 'KI',
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dial_code: '+850',
    emoji: '🇰🇵',
    code: 'KP',
  },
  {
    name: 'Korea, Republic of South Korea',
    dial_code: '+82',
    emoji: '🇰🇷',
    code: 'KR',
  },
  {
    name: 'Kuwait',
    dial_code: '+965',
    emoji: '🇰🇼',
    code: 'KW',
  },
  {
    name: 'Kyrgyzstan',
    dial_code: '+996',
    emoji: '🇰🇬',
    code: 'KG',
  },
  {
    name: 'Laos',
    dial_code: '+856',
    emoji: '🇱🇦',
    code: 'LA',
  },
  {
    name: 'Latvia',
    dial_code: '+371',
    emoji: '🇱🇻',
    code: 'LV',
  },
  {
    name: 'Lebanon',
    dial_code: '+961',
    emoji: '🇱🇧',
    code: 'LB',
  },
  {
    name: 'Lesotho',
    dial_code: '+266',
    emoji: '🇱🇸',
    code: 'LS',
  },
  {
    name: 'Liberia',
    dial_code: '+231',
    emoji: '🇱🇷',
    code: 'LR',
  },
  {
    name: 'Libyan Arab Jamahiriya',
    dial_code: '+218',
    emoji: '🇱🇾',
    code: 'LY',
  },
  {
    name: 'Liechtenstein',
    dial_code: '+423',
    emoji: '🇱🇮',
    code: 'LI',
  },
  {
    name: 'Lithuania',
    dial_code: '+370',
    emoji: '🇱🇹',
    code: 'LT',
  },
  {
    name: 'Luxembourg',
    dial_code: '+352',
    emoji: '🇱🇺',
    code: 'LU',
  },
  {
    name: 'Macao',
    dial_code: '+853',
    emoji: '🇲🇴',
    code: 'MO',
  },
  {
    name: 'Macedonia',
    dial_code: '+389',
    emoji: '🇲🇰',
    code: 'MK',
  },
  {
    name: 'Madagascar',
    dial_code: '+261',
    emoji: '🇲🇬',
    code: 'MG',
  },
  {
    name: 'Malawi',
    dial_code: '+265',
    emoji: '🇲🇼',
    code: 'MW',
  },
  {
    name: 'Malaysia',
    dial_code: '+60',
    emoji: '🇲🇾',
    code: 'MY',
  },
  {
    name: 'Maldives',
    dial_code: '+960',
    emoji: '🇲🇻',
    code: 'MV',
  },
  {
    name: 'Mali',
    dial_code: '+223',
    emoji: '🇲🇱',
    code: 'ML',
  },
  {
    name: 'Malta',
    dial_code: '+356',
    emoji: '🇲🇹',
    code: 'MT',
  },
  {
    name: 'Marshall Islands',
    dial_code: '+692',
    emoji: '🇲🇭',
    code: 'MH',
  },
  {
    name: 'Martinique',
    dial_code: '+596',
    emoji: '🇲🇶',
    code: 'MQ',
  },
  {
    name: 'Mauritania',
    dial_code: '+222',
    emoji: '🇲🇷',
    code: 'MR',
  },
  {
    name: 'Mauritius',
    dial_code: '+230',
    emoji: '🇲🇺',
    code: 'MU',
  },
  {
    name: 'Mayotte',
    dial_code: '+262',
    emoji: '🇾🇹',
    code: 'YT',
  },
  {
    name: 'Mexico',
    dial_code: '+52',
    emoji: '🇲🇽',
    code: 'MX',
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    dial_code: '+691',
    emoji: '🇫🇲',
    code: 'FM',
  },
  {
    name: 'Moldova',
    dial_code: '+373',
    emoji: '🇲🇩',
    code: 'MD',
  },
  {
    name: 'Monaco',
    dial_code: '+377',
    emoji: '🇲🇨',
    code: 'MC',
  },
  {
    name: 'Mongolia',
    dial_code: '+976',
    emoji: '🇲🇳',
    code: 'MN',
  },
  {
    name: 'Montenegro',
    dial_code: '+382',
    emoji: '🇲🇪',
    code: 'ME',
  },
  {
    name: 'Montserrat',
    dial_code: '+1664',
    emoji: '🇲🇸',
    code: 'MS',
  },
  {
    name: 'Morocco',
    dial_code: '+212',
    emoji: '🇲🇦',
    code: 'MA',
  },
  {
    name: 'Mozambique',
    dial_code: '+258',
    emoji: '🇲🇿',
    code: 'MZ',
  },
  {
    name: 'Myanmar',
    dial_code: '+95',
    emoji: '🇲🇲',
    code: 'MM',
  },
  {
    name: 'Namibia',
    emoji: '🇳🇦',
    dial_code: '+264',
    code: 'NA',
  },
  {
    name: 'Nauru',
    dial_code: '+674',
    emoji: '🇳🇷',
    code: 'NR',
  },
  {
    name: 'Nepal',
    dial_code: '+977',
    emoji: '🇳🇵',
    code: 'NP',
  },
  {
    name: 'Netherlands',
    dial_code: '+31',
    emoji: '🇳🇱',
    code: 'NL',
  },
  {
    name: 'Netherlands Antilles',
    dial_code: '+599',
    emoji: '🇧🇶',
    code: 'AN',
  },
  {
    name: 'New Caledonia',
    dial_code: '+687',
    emoji: '🇳🇨',
    code: 'NC',
  },
  {
    name: 'New Zealand',
    dial_code: '+64',
    emoji: '🇳🇿',
    code: 'NZ',
  },
  {
    name: 'Nicaragua',
    dial_code: '+505',
    emoji: '🇳🇮',
    code: 'NI',
  },
  {
    name: 'Niger',
    dial_code: '+227',
    emoji: '🇳🇪',
    code: 'NE',
  },
  {
    name: 'Nigeria',
    dial_code: '+234',
    emoji: '🇳🇬',
    code: 'NG',
  },
  {
    name: 'Niue',
    dial_code: '+683',
    emoji: '🇳🇺',
    code: 'NU',
  },
  {
    name: 'Norfolk Island',
    dial_code: '+672',
    emoji: '🇳🇫',
    code: 'NF',
  },
  {
    name: 'Northern Mariana Islands',
    dial_code: '+1670',
    emoji: '🇲🇵',
    code: 'MP',
  },
  {
    name: 'Norway',
    dial_code: '+47',
    emoji: '🇳🇴',
    code: 'NO',
  },
  {
    name: 'Oman',
    dial_code: '+968',
    emoji: '🇴🇲',
    code: 'OM',
  },
  {
    name: 'Pakistan',
    dial_code: '+92',
    emoji: '🇵🇰',
    code: 'PK',
  },
  {
    name: 'Palau',
    dial_code: '+680',
    emoji: '🇵🇼',
    code: 'PW',
  },
  {
    name: 'Palestinian Territory, Occupied',
    dial_code: '+970',
    emoji: '🇵🇸',
    code: 'PS',
  },
  {
    name: 'Panama',
    dial_code: '+507',
    emoji: '🇵🇦',
    code: 'PA',
  },
  {
    name: 'Papua New Guinea',
    dial_code: '+675',
    emoji: '🇵🇬',
    code: 'PG',
  },
  {
    name: 'Paraguay',
    dial_code: '+595',
    emoji: '🇵🇾',
    code: 'PY',
  },
  {
    name: 'Peru',
    dial_code: '+51',
    emoji: '🇵🇪',
    code: 'PE',
  },
  {
    name: 'Philippines',
    dial_code: '+63',
    emoji: '🇵🇭',
    code: 'PH',
  },
  {
    name: 'Pitcairn',
    dial_code: '+872',
    emoji: '🇵🇳',
    code: 'PN',
  },
  {
    name: 'Poland',
    dial_code: '+48',
    emoji: '🇵🇱',
    code: 'PL',
  },
  {
    name: 'Portugal',
    dial_code: '+351',
    emoji: '🇵🇹',
    code: 'PT',
  },
  {
    name: 'Puerto Rico',
    dial_code: '+1939',
    emoji: '🇵🇷',
    code: 'PR',
  },
  {
    name: 'Qatar',
    dial_code: '+974',
    emoji: '🇶🇦',
    code: 'QA',
  },
  {
    name: 'Romania',
    dial_code: '+40',
    emoji: '🇷🇴',
    code: 'RO',
  },
  {
    name: 'Russia',
    dial_code: '+7',
    emoji: '🇷🇺',
    code: 'RU',
  },
  {
    name: 'Rwanda',
    dial_code: '+250',
    emoji: '🇷🇼',
    code: 'RW',
  },
  {
    name: 'Reunion',
    dial_code: '+262',
    emoji: '🇷🇪',
    code: 'RE',
  },
  {
    name: 'Saint Barthelemy',
    dial_code: '+590',
    emoji: '🇧🇱',
    code: 'BL',
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    dial_code: '+290',
    emoji: '🇸🇭',
    code: 'SH',
  },
  {
    name: 'Saint Kitts and Nevis',
    dial_code: '+1869',
    emoji: '🇰🇳',
    code: 'KN',
  },
  {
    name: 'Saint Lucia',
    dial_code: '+1758',
    emoji: '🇱🇨',
    code: 'LC',
  },
  {
    name: 'Saint Martin',
    dial_code: '+590',
    emoji: '🇲🇫',
    code: 'MF',
  },
  {
    name: 'Saint Pierre and Miquelon',
    dial_code: '+508',
    emoji: '🇵🇲',
    code: 'PM',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    dial_code: '+1784',
    emoji: '🇻🇨',
    code: 'VC',
  },
  {
    name: 'Samoa',
    dial_code: '+685',
    emoji: '🇼🇸',
    code: 'WS',
  },
  {
    name: 'San Marino',
    dial_code: '+378',
    emoji: '🇸🇲',
    code: 'SM',
  },
  {
    name: 'Sao Tome and Principe',
    dial_code: '+239',
    emoji: '🇸🇹',
    code: 'ST',
  },
  {
    name: 'Saudi Arabia',
    dial_code: '+966',
    emoji: '🇸🇦',
    code: 'SA',
  },
  {
    name: 'Senegal',
    dial_code: '+221',
    emoji: '🇸🇳',
    code: 'SN',
  },
  {
    name: 'Serbia',
    dial_code: '+381',
    emoji: '🇷🇸',
    code: 'RS',
  },
  {
    name: 'Seychelles',
    dial_code: '+248',
    emoji: '🇸🇨',
    code: 'SC',
  },
  {
    name: 'Sierra Leone',
    dial_code: '+232',
    emoji: '🇸🇱',
    code: 'SL',
  },
  {
    name: 'Singapore',
    dial_code: '+65',
    emoji: '🇸🇬',
    code: 'SG',
  },
  {
    name: 'Slovakia',
    dial_code: '+421',
    emoji: '🇸🇰',
    code: 'SK',
  },
  {
    name: 'Slovenia',
    dial_code: '+386',
    emoji: '🇸🇮',
    code: 'SI',
  },
  {
    name: 'Solomon Islands',
    dial_code: '+677',
    emoji: '🇸🇧',
    code: 'SB',
  },
  {
    name: 'Somalia',
    dial_code: '+252',
    emoji: '🇸🇴',
    code: 'SO',
  },
  {
    name: 'South Africa',
    dial_code: '+27',
    emoji: '🇿🇦',
    code: 'ZA',
  },
  {
    name: 'South Sudan',
    dial_code: '+211',
    emoji: '🇸🇸',
    code: 'SS',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    dial_code: '+500',
    emoji: '🇬🇸',
    code: 'GS',
  },
  {
    name: 'Spain',
    dial_code: '+34',
    emoji: '🇪🇸',
    code: 'ES',
  },
  {
    name: 'Sri Lanka',
    dial_code: '+94',
    emoji: '🇱🇰',
    code: 'LK',
  },
  {
    name: 'Sudan',
    dial_code: '+249',
    emoji: '🇸🇩',
    code: 'SD',
  },
  {
    name: 'Suriname',
    dial_code: '+597',
    emoji: '🇸🇷',
    code: 'SR',
  },
  {
    name: 'Svalbard and Jan Mayen',
    dial_code: '+47',
    emoji: '🇸🇯',
    code: 'SJ',
  },
  {
    name: 'Swaziland',
    dial_code: '+268',
    emoji: '🇸🇿',
    code: 'SZ',
  },
  {
    name: 'Sweden',
    dial_code: '+46',
    emoji: '🇸🇪',
    code: 'SE',
  },
  {
    name: 'Switzerland',
    dial_code: '+41',
    emoji: '🇨🇭',
    code: 'CH',
  },
  {
    name: 'Syrian Arab Republic',
    dial_code: '+963',
    emoji: '🇸🇾',
    code: 'SY',
  },
  {
    name: 'Taiwan',
    dial_code: '+886',
    emoji: '🇹🇼',
    code: 'TW',
  },
  {
    name: 'Tajikistan',
    dial_code: '+992',
    emoji: '🇹🇯',
    code: 'TJ',
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    dial_code: '+255',
    emoji: '🇹🇿',
    code: 'TZ',
  },
  {
    name: 'Thailand',
    dial_code: '+66',
    emoji: '🇹🇭',
    code: 'TH',
  },
  {
    name: 'Timor-Leste',
    dial_code: '+670',
    emoji: '🇹🇱',
    code: 'TL',
  },
  {
    name: 'Togo',
    dial_code: '+228',
    emoji: '🇹🇬',
    code: 'TG',
  },
  {
    name: 'Tokelau',
    dial_code: '+690',
    emoji: '🇹🇰',
    code: 'TK',
  },
  {
    name: 'Tonga',
    dial_code: '+676',
    emoji: '🇹🇴',
    code: 'TO',
  },
  {
    name: 'Trinidad and Tobago',
    dial_code: '+1868',
    emoji: '🇹🇹',
    code: 'TT',
  },
  {
    name: 'Tunisia',
    dial_code: '+216',
    emoji: '🇹🇳',
    code: 'TN',
  },
  {
    name: 'Turkey',
    dial_code: '+90',
    emoji: '🇹🇷',
    code: 'TR',
  },
  {
    name: 'Turkmenistan',
    dial_code: '+993',
    emoji: '🇹🇲',
    code: 'TM',
  },
  {
    name: 'Turks and Caicos Islands',
    dial_code: '+1649',
    emoji: '🇹🇨',
    code: 'TC',
  },
  {
    name: 'Tuvalu',
    dial_code: '+688',
    emoji: '🇹🇻',
    code: 'TV',
  },
  {
    name: 'Uganda',
    dial_code: '+256',
    emoji: '🇺🇬',
    code: 'UG',
  },
  {
    name: 'Ukraine',
    dial_code: '+380',
    emoji: '🇺🇦',
    code: 'UA',
  },
  {
    name: 'United Arab Emirates',
    dial_code: '+971',
    emoji: '🇦🇪',
    code: 'AE',
  },
  {
    name: 'United Kingdom',
    dial_code: '+44',
    emoji: '🇬🇧',
    code: 'GB',
  },
  {
    name: 'United States',
    dial_code: '+1',
    emoji: '🇺🇸',
    code: 'US',
  },
  {
    name: 'Uruguay',
    dial_code: '+598',
    emoji: '🇺🇾',
    code: 'UY',
  },
  {
    name: 'Uzbekistan',
    dial_code: '+998',
    emoji: '🇺🇿',
    code: 'UZ',
  },
  {
    name: 'Vanuatu',
    dial_code: '+678',
    emoji: '🇻🇺',
    code: 'VU',
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    dial_code: '+58',
    emoji: '🇻🇪',
    code: 'VE',
  },
  {
    name: 'Vietnam',
    dial_code: '+84',
    emoji: '🇻🇳',
    code: 'VN',
  },
  {
    name: 'Virgin Islands, British',
    dial_code: '+1284',
    emoji: '🇻🇬',
    code: 'VG',
  },
  {
    name: 'Virgin Islands, U.S.',
    dial_code: '+1340',
    emoji: '🇻🇮',
    code: 'VI',
  },
  {
    name: 'Wallis and Futuna',
    dial_code: '+681',
    emoji: '🇼🇫',
    code: 'WF',
  },
  {
    name: 'Yemen',
    dial_code: '+967',
    emoji: '🇾🇪',
    code: 'YE',
  },
  {
    name: 'Zambia',
    dial_code: '+260',
    emoji: '🇿🇲',
    code: 'ZM',
  },
  {
    name: 'Zimbabwe',
    dial_code: '+263',
    emoji: '🇿🇼',
    code: 'ZW',
  },
]

export const formattedCountryCodes = countryCodes.map((code) => {
  return {
    label: ` ${code.dial_code}`,
    // label: `${code.emoji} ${code.dial_code}`,
    displayLabel: `${code.emoji} ${code.name} (${code.dial_code})`,
    value: code.dial_code,
    searchText: `${code.name} ${code.dial_code}`,
    key: code.code,
  }
})
